import { render, staticRenderFns } from "./AddDependentsCard.vue?vue&type=template&id=3574918a&lang=pug&"
import script from "./AddDependentsCard.vue?vue&type=script&lang=js&"
export * from "./AddDependentsCard.vue?vue&type=script&lang=js&"
import style0 from "./AddDependentsCard.vue?vue&type=style&index=0&id=3574918a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports